import { integrationMiddleware } from "../network/middlewareHttp";
import { baseURL } from "./FetchUrl";

class SupplierOrderDetails{
    apiURL = baseURL
    getEndpoint = '/api/SuppliersOrders/get'
    postEndpoint = '/api/SuppliersOrders/post'
    putEndpoint = '/api/SuppliersOrders/put'
    deleteEndpoint = '/api/SuppliersOrders/delete'
    http = integrationMiddleware(this.apiURL, 'AUTH TOKEN')
    
    getSupplierOrderDetails = async() => {
        return new Promise(async(resolve, reject) => {
            this.http.get(this.apiURL + this.getEndpoint)
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }
    postSupplierOrderDetails = async(body) => {
        return new Promise(async(resolve, reject) => {
            this.http.post(this.apiURL + this.postEndpoint, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    deleteSupplierOrderDetails = async(id) => {
        return new Promise(async(resolve, reject) => {
            this.http.delete(this.apiURL + this.deleteEndpoint + '/' + id )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

    updateSupplierOrderDetails = async(id, body) => {
        return new Promise(async(resolve, reject) => {
            this.http.put(this.apiURL + this.putEndpoint + '/' + id, body )
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
        })
    }

}

export default SupplierOrderDetails
